import { extendTheme } from "@chakra-ui/react";

const Container = {
  baseStyle: {
    maxW: "80ch",
  },
};

const descriptionWrapper = {
  ".description-container": {
    h1: {
      fontFamily: "heading",
      fontSize: "2xl",
    },
    p: {
      marginBottom: 3,
    },
    a: {
      color: "teal",
      textDecoration: "underline",
    },
  },
};

const notesWrapper = {
  ".notes-container": {
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "heading",
    },
    h1: {
      fontFamily: "heading",
      fontSize: "2xl",
    },
    h2: {
      fontSize: "xl",
    },
    h3: {
      fontSize: "lg",
    },
    p: {
      marginBottom: 3,
    },
    a: {
      color: "teal",
      textDecoration: "underline",
    },
  },
};

const theme = extendTheme({
  styles: {
    global: { ...descriptionWrapper, ...notesWrapper },
  },
  components: {
    Container,
  },
});

export { theme };
